
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 463.89 438.88","version":"1.0","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M394.811 223.1zL231.991 78.91l-162.9 144.25v206.12c0 5.33 4.3 9.6 9.62 9.6h101.81V348.5c0-5.32 4.27-9.62 9.6-9.62h83.65c5.33 0 9.6 4.3 9.6 9.62v90.38h101.84c5.32 0 9.6-4.27 9.6-9.6V223.1zm-325.72.06z"}}),_c('path',{attrs:{"d":"M231.051 0L.001 204.59l24.338 27.45 207.65-183.88 207.61 183.88 24.29-27.45L232.889 0l-.9 1.04-.94-1.04zM69.091 29.45h58.57l-.51 34.69-58.06 52.45V29.45z"}})])
          )
        }
      }
    